import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";

import LiveTextField from "../../../forms/custom/LiveTextField";
import { WorkEmailTooltip } from "../../../shared/Individual/Settings/IndividualProfile";

import SectionHeader from "./SectionHeader";

function OnlineTermsLink({ termsLink, label = "online terms" }) {
  return (
    <a
      className="semibold"
      href={termsLink}
      rel="noopener noreferrer"
      target="_blank"
      style={{
        textDecoration: "underline",
      }}
    >
      {label}
    </a>
  );
}

export const AgreesToTermsField = withStyles({
  termsFieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: "#FF6D6D",
  },
})(
  ({
    values,
    touched,
    errors,
    setFieldTouched,
    setFieldValue,
    classes,
    talk,
  }) => {
    const termsLinkLabel = "permanent placement online terms";

    const error = Boolean(touched.agrees_to_terms && errors.agrees_to_terms);

    const handleChange = () => {
      setFieldTouched("agrees_to_terms", true);
      setFieldValue("agrees_to_terms", !values.agrees_to_terms);
    };

    const termsLink = talk
      ? "https://www.talktalent.com/terms"
      : "https://www.recruitifi.com/terms/";

    return (
      <div>
        <FormControlLabel
          control={(
            <Checkbox
              id="agrees_to_terms"
              checked={values.agrees_to_terms}
              onChange={handleChange}
              color={error ? "secondary" : "primary"}
              classes={{ colorSecondary: classes.error }}
              data-cy="agree-to-terms-checkbox"
            />
          )}
          label={(
            <span>
              I accept the
              {" "}
              <OnlineTermsLink {...{ termsLink, label: termsLinkLabel }} />
            </span>
          )}
          style={{
            paddingLeft: 12,
          }}
        />
      </div>
    );
  }
);

export const AgreesToTempTermsField = withStyles({
  termsFieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: "#FF6D6D",
  },
})(({
  values, touched, errors, setFieldTouched, setFieldValue, classes
}) => {
  const error = Boolean(
    touched.agrees_to_temp_terms && errors.agrees_to_temp_terms
  );

  const handleChange = () => {
    setFieldTouched("agrees_to_temp_terms", true);
    setFieldValue("agrees_to_temp_terms", !values.agrees_to_temp_terms);
  };

  return (
    <div>
      <FormControlLabel
        control={(
          <Checkbox
            id="agrees_to_temp_terms"
            checked={values.agrees_to_temp_terms}
            onChange={handleChange}
            color={error ? "secondary" : "primary"}
            classes={{ colorSecondary: classes.error }}
            data-cy="agree-to-temp-terms-checkbox"
          />
        )}
        label={(
          <span>
            I accept the
            {" "}
            <OnlineTermsLink
              termsLink="https://www.recruitifi.com/contract-terms"
              label="contract workforce online terms"
            />
          </span>
        )}
        style={{
          paddingLeft: 12,
        }}
      />
    </div>
  );
});

export function PasswordField({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
}) {
  return (
    <TextField
      id="password"
      error={Boolean(errors.password && touched.password)}
      helperText={touched.password && errors.password}
      label="create password"
      type="password"
      style={{ width: "calc(100% - 35px)" }}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.password}
      inputProps={{ "data-cy": "password" }}
    />
  );
}

export function EmailField({
  disabled,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  validationUrl,
}) {
  return disabled ? (
    <TextField
      id="email"
      label={<WorkEmailTooltip />}
      value={values.email}
      disabled
      style={{ width: "calc(100% - 35px)" }}
      InputLabelProps={{ shrink: true }}
    />
  ) : (
    <LiveTextField
      frontendError={errors.email}
      error={Boolean(touched.email && errors.email)}
      helperText={touched.email && errors.email}
      label={<WorkEmailTooltip />}
      id="email"
      onChange={handleChange}
      onBlur={handleBlur}
      validator={{ email: true }}
      validationUrl={
        validationUrl || "/api/v3/public/validations/individual_email"
      }
      value={values.email}
      inputProps={{ "data-cy": "email" }}
    />
  );
}

export function OrganizationNameField({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
}) {
  return (
    <TextField
      id="organization_name"
      error={Boolean(touched.organization_name && errors.organization_name)}
      helperText={touched.organization_name && errors.organization_name}
      label="Agency Name"
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.organization_name}
      style={{ width: "calc(100% - 35px)" }}
      inputProps={{ maxLength: 100, "data-cy": "organization-name" }}
    />
  );
}

export function FieldSection({ children }) {
  return (
    <>
      <SectionHeader title="Begin your application" />
      <div style={{ width: "80%", marginLeft: 12 }}>{children}</div>
    </>
  );
}
